import { ValidatorService } from './../../../services/tools/validator.service';
import { Message1ModalComponent } from './../../tools/modals/message1-modal/message1-modal.component';
import { AutenticacionService } from './../../../services/autenticacion.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-generar-password',
  templateUrl: './generar-password.component.html',
  styleUrls: ['./generar-password.component.scss']
})
export class GenerarPasswordComponent implements OnInit {

  public token: string;
  public old_password: string;
  public new_password: string;
  public confirm_password: string;
  public key_password?: string;

  public modo_sobre = false;

  @ViewChild(Message1ModalComponent) message1Modal: Message1ModalComponent;

  constructor(private activedRoute: ActivatedRoute, private authService: AutenticacionService, private validatorService: ValidatorService, private router: Router) {
    this.activedRoute.queryParams.subscribe(params => {
      this.token = params['key'];
      this.modo_sobre = params['modo_sobre'] && params['modo_sobre'] == 1;
    });

    this.redirectLogin = this.redirectLogin.bind(this);
  }

  ngOnInit() {
  }

  generatePassword() {

    if(!this.canGeneratePassword()) {
      return false;
    }

    const error = this.validatePassword();
    if (error) {
      this.openModalMessage(error);
      return false;
    }
    this.authService.generarPassword(this.token, this.old_password, this.new_password, this.key_password)
      .subscribe(response => {
        const user = response.json().content;
        this.openModalMessage('La contraseña se restableció con éxito. Deberás iniciar sesión con tu correo electrónico y la nueva contraseña.', 'Contraseña actualizada', this.redirectLogin);
      }, error => {
        const error_content = error.json().content;
        let message = 'No se completó la acción. Por favor, intentelo más tarde.';
        if (error.status == 400 && error_content.token) {
          this.openModalMessage('La solicitud para recuperar contraseña ha expirado', 'Actualización de contraseña', this.redirectLogin);
        } else{
          if (error.status == 400 && error_content.message) {
            message = error_content.message;
          }

          this.openModalMessage(message);
        }

      });
  }

  modalCallback(callback) {
    callback();
  }

  redirectLogin() {
    this.router.navigate(['login']);
  }

  openModalMessage(message, title = 'Actualización de contraseña', callback = undefined) {
    this.message1Modal.open({
      'title': title,
      'message': message,
      'callback': callback
    });
  }

  validatePassword() {
    let error = undefined;

    if (this.new_password != this.confirm_password) {
      error = 'La nueva contraseña ingresada no coincide con la confirmación, por favor verifica nuevamente.';
    } else if (this.new_password.length != 8) {
      error = 'La contraseña deberá estar conformada por 8 caracteres';
    }

    return error;
  }

  canGeneratePassword() {
    const canGenerate = (this.validatorService.required(this.old_password) && this.validatorService.required(this.new_password) && this.validatorService.required(this.confirm_password));
    return canGenerate;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/autenticacion/generar-password/generar-password.component.ts